export const getTotalActiveFilterCount = (
    fromPrice,
    toPrice,
    attributeFilters,
    activeFilters
) => {
    const getAttributeFilterCount = () => {
        let count = 0;
        attributeFilters.map(
            attributeFilter =>
                (count = count + attributeFilter.selectedValues.length)
        );
        return count;
    };

    const userSetPriceFilter =
        fromPrice && (fromPrice.value > 1 || toPrice.value < 5000);
    const totalAttributeFilters = getAttributeFilterCount();
    const totalActiveFilters =
        activeFilters.length + totalAttributeFilters + userSetPriceFilter;
    return totalActiveFilters;
};
